import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface ProductUnit {
  unit_name: string
  abbreviation: string
}

// ─── Unit APIs ────────────────────────────────────────────────────────────────

export const getUnits = async (companyId: string): Promise<ProductUnit[] | undefined> => {
  return await axios
    .get(`${API_URL}/product-catalogue/data/${companyId}`)
    .then((response: AxiosResponse<{units: ProductUnit[]}>) => response.data)
    .then((response) => response.units)
}

export const createUnit = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/product-catalogue/unit`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const editUnit = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.put(`${API_URL}/product-catalogue/unit/edit`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const deleteUnit = async (
  companyId: string,
  unitName: string
): Promise<{detail: string} | undefined> => {
  return await axios
    .delete(`${API_URL}/product-catalogue/unit/${companyId}/${unitName}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}
